import * as tslib_1 from "tslib";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { UserRepositoryInterface } from "../../datastore/repositories/user/user.interface";
import { concatMap, map, tap } from "rxjs/operators";
var UserManager = /** @class */ (function (_super) {
    tslib_1.__extends(UserManager, _super);
    function UserManager(localStorageRepository, userRepository) {
        var _this = _super.call(this, localStorageRepository) || this;
        _this.localStorageRepository = localStorageRepository;
        _this.userRepository = userRepository;
        return _this;
    }
    UserManager.prototype.login = function (email, password) {
        var _this = this;
        return this.userRepository.login(email, password).pipe(tap(function (loginModel) {
            _this.localStorageRepository.setToken(loginModel.token);
            _this.localStorageRepository.setRefreshToken(loginModel.refreshToken);
        }), concatMap(function () { return _this.userRepository.getLoggedUser()
            .pipe(tap(function (user) {
            _this.localStorageRepository.setLoggedEmail(user.email);
            _this.localStorageRepository.setLoggedUserId(user.uuid);
        })); }));
    };
    UserManager.prototype.logout = function () {
        this.localStorageRepository.removeToken();
        this.localStorageRepository.removeRefreshToken();
        this.localStorageRepository.removeLoggedEmail();
        this.localStorageRepository.removeLoggedUserId();
        this.localStorageRepository.removeInfoPlantToken();
        this.localStorageRepository.removeCurrentLanguage();
    };
    UserManager.prototype.getProfile = function (id) {
        return this.userRepository.getProfile(id);
    };
    UserManager.prototype.getLoggedUserEmail = function () {
        return this.localStorageRepository.getLoggedEmail();
    };
    UserManager.prototype.getInfoPlantUser = function (email, password) {
        var _this = this;
        return this.userRepository.getInfoPlantUser(email, password).pipe(tap(function (infoPlantUserModel) {
            if (infoPlantUserModel.userAuth) {
                _this.localStorageRepository.setInfoPlantToken(infoPlantUserModel.email);
            }
        }), map(function (infoPlantUserModel) {
            return infoPlantUserModel.userAuth;
        }));
    };
    UserManager.prototype.getLoggedUserId = function () {
        return this.localStorageRepository.getLoggedUserId();
    };
    UserManager.prototype.createUser = function (email) {
        return this.userRepository.createUser(email);
    };
    UserManager.prototype.changePassword = function (oldPassword, newPassword) {
        return this.userRepository.changePassword(oldPassword, newPassword, "me");
    };
    UserManager.prototype.getResources = function () {
        return this.userRepository.getResources();
    };
    UserManager.prototype.updateLoggedUser = function () {
        var _this = this;
        return this.userRepository.getLoggedUser().pipe(tap(function (user) {
            _this.localStorageRepository.setLoggedEmail(user.email);
            _this.localStorageRepository.setLoggedUserId(user.uuid);
        }));
    };
    return UserManager;
}(BaseManager));
export { UserManager };
